import React from "react";

export default function DolciDrinkTeaser() {
  return (
    <section id="dolci-drink" className="relative bg-[#0C0C0C] grain py-16 sm:py-20 border-t border-[#161616]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 relative z-10 text-center">
        <span className="font-display font-bold uppercase tracking-[0.3em] text-sm text-[#FFC20E]">DOLCI & DRINK</span>
        <h2 className="font-display font-black uppercase display-tight text-5xl sm:text-7xl mt-2">
          <span className="text-white">STIAMO </span>
          <span className="text-[#FFC20E]">PREPARANDO </span>
          <span className="text-white">ALTRI MORSI.</span>
        </h2>
        <p className="mt-5 text-white/60 text-lg max-w-xl mx-auto">
          Finisci in bellezza e bevi la voglia. Presto qui. Chi è nel Club lo sa prima.
        </p>
        <span className="mt-6 inline-block font-hand text-3xl text-[#FFC20E] -rotate-2">presto disponibili</span>
      </div>
    </section>
  );
}
